import React, { useRef, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { splitMessageIntoLines } from '../utils/messageUtils';

const ChatMessages = ({
  messages,
  isTyping,
  showScrollToBottom,
  onScroll,
  onScrollToBottom,
}) => {
  const messagesEndRef = useRef(null);
  const messagesContainerRef = useRef(null);

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  // Auto-scroll to bottom when new messages arrive
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
    
    return () => clearTimeout(timeoutId);
  }, [messages, isTyping]);

  const handleScroll = () => {
    const container = messagesContainerRef.current;
    if (container) {
      const { scrollTop, scrollHeight, clientHeight } = container;
      const isNearBottom = scrollHeight - scrollTop - clientHeight < 100;
      // Call parent's scroll handler
      onScroll();
    }
  };

  return (
    <Box 
      ref={messagesContainerRef}
      className="chat-messages"
      onScroll={handleScroll}
    >
      {messages.map((message) => (
        <Box
          key={message.id}
          className={`message ${message.sender}`}
        >
          <Box className="message-content">
            <Typography variant="body1" className="message-text" component="div">
              {splitMessageIntoLines(message.message).map((line, index, array) => (
                <React.Fragment key={index}>
                  {line}
                  {index < array.length - 1 && <br />}
                </React.Fragment>
              ))}
            </Typography>
            <Typography variant="caption" className="message-time">
              {formatTime(message.timestamp)}
            </Typography>
          </Box>
        </Box>
      ))}
      
      {/* Typing Indicator */}
      {isTyping && (
        <Box className="message support typing-indicator">
          <Box className="message-content">
            <Typography variant="body2" className="typing-text">
              Support is typing...
            </Typography>
            <Box className="typing-dots">
              <span></span>
              <span></span>
              <span></span>
            </Box>
          </Box>
        </Box>
      )}
      
      {/* Scroll target element */}
      <div ref={messagesEndRef} />
    </Box>
  );
};

export default ChatMessages;
